const MAX_FILE_NAME_LENGTH = 255;

export const sanitizeFileNameSegment = (value: string): string =>
  value
    .replace(/[/\\:*?"<>|]/g, '-')
    .replace(/\s+/g, ' ')
    .trim();

export interface AtaDownloadFileNameInput {
  fortnoxId?: string | null;
  projectName?: string | null;
  serialNumber?: number | null;
}

export const buildAtaDownloadFileName = ({
  fortnoxId,
  projectName,
  serialNumber,
}: AtaDownloadFileNameInput): string => {
  const projectNumber = fortnoxId ?? '';
  const serial = serialNumber ?? '';

  let base: string;
  if (projectNumber) {
    const name = sanitizeFileNameSegment(projectName ?? '');
    const primary = `${projectNumber}-${name}-äta-${serial}`;
    base =
      `${primary}.pdf`.length > MAX_FILE_NAME_LENGTH
        ? `projekt-${projectNumber}-äta-${serial}`
        : primary;
  } else {
    base = `äta-${serial}`;
  }

  return `${base}.pdf`;
};
